/*jshint esversion: 6 */
(function () {
    //TODO: revisit this function when you get to the review page.
    var redefineWeight = function() {
        var input = $(this);
        var name = input.attr('name');
        var approach = input.data('approach');
        var weight = toNumberFromPercent(input);
        var id = $('input[name="evaluation[id]"]').val();

        if(weight <= 1) {
            var incremental = getIncrementalValues();
            var weights = getNewWeightedValue(name, approach, weight, incremental);

            setTotalIncrementalValue(weights.weightedValue);
            setTotalPPSF();
            setApproachIncrementalValue(approach, weights.value);
            var total_incremental_value = $("#total_incremental_value_review").maskMoney('unmasked')[0];

            let url = $("body").data("base-url") + "approaches/save/";
            if (location.pathname.indexOf('/res_evaluations') !== -1)
                url = $("body").data("base-url") + "approaches/res_save/";
            $.ajax({
                type: "POST",
                url: url + $("input[name='evaluation_" + approach + "_approaches[id]']").val(),
                data: {
                    evaluation_id: id,
                    name: name,
                    eval_weight: weight,
                    approach: approach,
                    incremental: weights.value,
                    market_value: weights.weightedValue,
                    total_incremental_value: total_incremental_value
                },         
                success: function (responseText) {
                    var roundingVal = $("#rounding").val();
                    var acc;
                    var roundVal;
                    var total = $("input[name=total_incremental_value]").data('value');   
                    var originalVal = $("input[name=total_incremental_value]").val();   
                     
                    if(roundingVal==3){
                       acc = 1000;
                    }else if(roundingVal==5000){
                        acc = 5000; 
                     }else if(roundingVal==4){
                       acc = 10000; 
                    }else if(roundingVal==5){
                       acc = 100000; 
                    }else if(roundingVal==6){
                       acc = 1000000; 
                    }   
                    if(roundingVal!=0)
                    {    
                        total = Math.round(total/acc)*acc;
                        roundVal = total.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2,style: 'currency', currency: 'USD' });                
                    }
                    else    
                    {
                        roundVal = originalVal; 
                    }
                    $('#total_incremental_value').val(roundVal);
                },
                failure: function (errMsg) {
                    Materialize.toast("It was not possible to execute that action.", 2000);
                }
            });
        } else {
            Materialize.toast('Weight should be equal or under 100%.', 2000);
        }
    };

    /**
     * @returns {{income: number, sales: number, cost: number}}
     */
    var getIncrementalValues = function() {
        var income = !isNaN(parseFloat($("input[name='income_incremental_value']").data('value')))? parseFloat($("input[name='income_incremental_value']").data('value')) : 0;
        var sales = !isNaN(parseFloat($("input[name='sales_incremental_value']").data('value')))? parseFloat($("input[name='sales_incremental_value']").data('value')) : 0;
        var cost = !isNaN(parseFloat($("input[name='cost_incremental_value']").data('value')))? parseFloat($("input[name='cost_incremental_value']").data('value')) : 0;
       return {
            income: income,
            sales: sales,
            cost:  cost
       };
    };

    /**
     *
     * @param val
     */
    var setTotalIncrementalValue = function(val) {
        var elTotal =  $("input[name='total_incremental_value']");

        val = parseFloat(val).toFixed(2);
        elTotal.val(val).data('value', val);
        elTotal.keyup();
        // elTotal.maskMoney('mask');
    };


    var setTotalPPSF = function() {
        var PPSFTotal =  $("input[name='total_ppsf']"),
            elTotal =  $("input[name='total_incremental_value']").data('value'),
            elTotalDollar =  $("input[name='total_incremental_value']").val(),
            totalPPSF = 0.0,
            buildingSize = $("input[name='evaluation[building_size]']").val(),
            landSize = $("input[name='evaluation[land_size]']").val(),
            landDimension = $("input[name='evaluation[landDimension]']").val(),
            PPSQFTTotal =  $("input[name='total_ppsqft']"),
            totalPPSQFT = 0.0;
        
        if($("#selected_comp_type").val()=="land_only")
        {
            if (landDimension === 'ACRE' && $('#selected_analysis_type').val()!=='$/Acre') {
                landSize = landSize * 43560;
            } else {
                landSize = landSize;
            }
            totalPPSF = parseFloat(elTotal).toFixed(2) / parseFloat(landSize);
        }else if(buildingSize > 0){
            totalPPSF = parseFloat(elTotal).toFixed(2) / parseFloat(buildingSize);	
            totalPPSQFT = parseFloat(elTotal).toFixed(2) / parseFloat(buildingSize);	
            if($('#comparison_basis_field').length){
                let comparison_val = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                if($('#comparison_basis_field').val() != 'SF'){
                    let devide_by = $('#comparison_basis_'+comparison_val+'_value').val();
                    totalPPSF = parseFloat(elTotal).toFixed(2) / parseFloat(devide_by);
                    PPSQFTTotal.val(parseFloat(totalPPSQFT).toFixed(2));
                }
            }
        }

        PPSFTotal.val(parseFloat(totalPPSF).toFixed(2));
        PPSFTotal.attr('data-tooltip', elTotalDollar + '/Building Size').tooltip();
        PPSFTotal.keyup();
        // PPSFTotal.maskMoney('mask');
    };

    /**
     * @param approach
     * @param val
     */
    var setApproachIncrementalValue = function(approach, val) {
        var el =  $("input[name=" + approach + "_incremental_value]");
        el.val(parseFloat(val).toFixed(2));
        el.keyup();
        // el.maskMoney('mask');
        el.data('value', val);
    };



    /**
     *
     * @param name
     * @param approach
     * @param weight
     * @param incremental
     * @returns {{value: number, weightedValue: number}}
     */
    var getNewWeightedValue = function(name, approach, weight, incremental) {
        var weightedValue = 0.00;
        var value = 0.00;

        if(name === 'income_weight') {
            value = (weight) * $("input[name=" + approach + "_indicated_value]").data('value');
            weightedValue = value + incremental.sales + incremental.cost;
        } else if(name === 'sales_weight') {
            value = (weight) * $("input[name=" + approach + "_indicated_value]").data('value');
            weightedValue = incremental.income + value + incremental.cost;
        } else if(name === 'cost_weight') {
            value = (weight) * $("input[name=" + approach + "_indicated_value]").data('value');
            weightedValue = incremental.income + incremental.sales + value;
        }

        return {value: value, weightedValue: weightedValue};
    };

    var calculateAge = function () {
        var yearBuilt = parseFloat($("input[name='evaluation[year_built]']").val());
        var yearRemodeled = parseFloat($("input[name='evaluation[year_remodeled]']").val());
        var effectiveAge;
        if(!isNaN(yearBuilt) && !isNaN(yearRemodeled)) {
            var remodelEffect = toNumberFromPercent($("input[name='evaluation[cost_approach_improvement][remodel_effect]']"));

            effectiveAge = (yearRemodeled - yearBuilt) * (remodelEffect);
            var effectiveYearBuilt = parseInt(effectiveAge + yearBuilt);
            effectiveAge = new Date().getFullYear() - effectiveYearBuilt;

            if (!isNaN(effectiveAge)) {
                $("input[name='evaluation[cost_approach_improvement][effective_age]']").val(effectiveAge);
            }

            if (!isNaN(effectiveYearBuilt)) {
                $("input[name='evaluation[cost_approach_improvement][effective_year_built]']").val(effectiveYearBuilt);
            }
        }
        else
        {
            effectiveAge = new Date().getFullYear() - yearBuilt;
            $("input[name='evaluation[cost_approach_improvement][effective_year_built]']").val(yearBuilt);
            $("input[name='evaluation[cost_approach_improvement][effective_age]']").val(effectiveAge);
        }
    };

    /**
     * Calculate income approach amounts.
     * @returns {*}
     */
    var calculateIncome = function (save=0) {
        var values = ViewManager.getIncomeValues();

        //Net Income Total
        values.vacant = getVacantIncomeTotal(values);
        values.adjustedGross = getAdjustedGross(values);
        values.net = getNetIncomeTotal(values);

        //Indicated Value Range
        values.indicatedValueRange.monthly = getMonthlyIndicatedValueRange(values);
        values.indicatedValueRange.annual = getAnnualIndicatedValueRange(values);
        values.indicatedValueRange.sqFeet = getSqFtIndicatedValueRange(values);

        //Indicated Value PSF
        values.indicatedValuePSF.monthly = getMonthlyIndicatedValuePSF(values);
        values.indicatedValuePSF.annual = getAnnualIndicatedValuePSF(values);
        values.indicatedValuePSF.sqFeet = getSqFtIndicatedValuePSF(values);

        //Incremental Value PSF
        values.incrementalValue.monthly = getMonthlyIncrementalValuePSF(values);
        values.incrementalValue.annual = getAnnualIncrementalValuePSF(values);

        ViewManager.setIncomeValues(values);
        if (location.pathname.indexOf('/res_evaluations') !== -1)
            ViewManager.setResSidebar(values,save);
        else
            ViewManager.setSidebar(values,save);

        return values;
    };

    /**Calculate sales approach amount.
     * @returns {*}
     */
    var calculateSales = function(isAddDelete = 0) {
        var values = ViewManager.getSalesValues(isAddDelete);
        //Building size
        var buildingSize;
        if($("#selected_comp_type").val()=="land_only")
        {
            buildingSize = $('.comp-current').find("input[name='current[land_size]']").val();
            var dimensionInput = $('.comp-current').find("input[name='current[land_dimension]']");
            if (dimensionInput.val() === 'ACRE' && $('#selected_analysis_type').val() !== '$/Acre') {
                buildingSize = buildingSize * 43560; //convert to SF
            }
        }else{
            buildingSize = $('.comp-current').find("input[name='current[building_size]']").val();
        }
        
        //Total Average Adjusted
        if(values.totalAverageAdjusted > 0 && !isNaN(buildingSize)) {
            buildingSize = parseFloat(buildingSize);
            values.compAdj = buildingSize * values.totalAverageAdjusted.toFixed(2);
            if($('#comparison_basis_field').val() == 'SF' && $("#selected_comp_type").val() != "land_only"){
                let finalValue = 0;
                $('.data').each(function() { 
                    sqftValue = $(this).find('.sqft_value').val();
                    weightValue = $(this).find('.weightsf_value').val();
                    finalValue +=  getTotalSalesValue(values.totalAverageAdjusted.toFixed(2),sqftValue,weightValue );               
                });
                values.value = finalValue;
            }else{
                values.value = buildingSize * values.totalAverageAdjusted.toFixed(2);
            }
        }

        //Incremental Value
        if(values.value > 0) {
            var salesWeight = $('#sales-approach-percentage').attr('data-value');
            if(!isNotNull(salesWeight)) {
                salesWeight = 0;
            }
            
            values.incrementalValue = (salesWeight/100) * values.value;
        }
        ViewManager.setSalesValues(values);
        ViewManager.setSidebar(values,isAddDelete);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var calculateMultiFamilyApproach = function(isAddDelete = 0) {
        var values = ViewManager.getMultiValues(isAddDelete);

        ViewManager.setMultiValues(values);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var getTotalSalesValue = function (adjust,sf,weight)
    {
        let value = (sf*weight)/100;
        let total = adjust*value;
        return total  
    }

    var calculateCost = function(isAddDelete = 0) {
        var values = ViewManager.getCostValues(isAddDelete);

        ViewManager.setCostValues(values);
        ViewManager.setSidebar(values,isAddDelete);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var updateSidebar = function (save=0) {
        var segments = location.pathname.split("/");

        if(isInArray('cost', segments) || isInArray('cost-improvement', segments)) {
            if(location.pathname.indexOf('res_evaluations/') !== -1) {
                calculateResCost(save);
            }else{
                calculateCost(save);
                calculateAge();
            }
        } else if(isInArray('sales', segments)) {
            if(location.pathname.indexOf('res_evaluations/') !== -1) {
                calculateResSales(save);
            }else{
                calculateSales(save);
            }
        } else if(isInArray('income', segments)) {
            if(location.pathname.indexOf('res_evaluations/') !== -1) {
                calculateResIncome(save);
            }else{
                calculateIncome(save);
            }
        } else if(isInArray('multiFamilyComps', segments)) {
            if(location.pathname.indexOf('multiFamilyComps/') !== -1) {
                calculateMultiFamilyApproach(save);
            }
        } else {
            if(location.pathname.indexOf('res_evaluations/') !== -1) {
                ViewManager.setResSidebar();
            }else{
                ViewManager.setSidebar();
            }
        }
    };

    /**
     * Calculate net income total for Income Approach.
     * @param obj
     * @returns {number}
     */
    var getNetIncomeTotal = function (obj) {
        return obj.adjustedGross - obj.expenses.annual;
    };

    /**
     * @param obj
     * @returns {number}
     */
    var getVacantIncomeTotal = function (obj) {
        return (obj.incomes.annual * (obj.vacancy / 100))*-1;
    };

    /**
     * Get adjusted gross.
     * @param obj
     * @returns {number}
     */
    var getAdjustedGross = function (obj) {
        return obj.incomes.annual + obj.vacant;
    };

    /**
     * Calculate monthly indicated value range.
     * @param obj
     * @returns {number}
     */
    var getMonthlyIndicatedValueRange = function(obj) {
        if(obj.net > 0 && obj.rate.monthly > 0) {
            return obj.net/(obj.rate.monthly/100);
        } else {
            return obj.indicatedValueRange.monthly;
        }
    };

    /**
     * Calculate annual indicated value range.
     * @param obj
     * @returns {number}
     */
    var getAnnualIndicatedValueRange = function(obj) {
        if(obj.net > 0 && obj.rate.annual > 0) {
            return obj.net/(obj.rate.annual/100);
        } else {
            return obj.indicatedValueRange.annual;
        }
    };

    /**
     * Calculate square feet indicated value range.
     * @param obj
     * @returns {number}
     */
    var getSqFtIndicatedValueRange = function(obj) {
        if(obj.net > 0 && obj.rate.sqFeet > 0) {
            return obj.net/(obj.rate.sqFeet/100);
        } else {
            return obj.indicatedValueRange.sqFeet;
        }
    };

    /**
     * Calculate monthly indicated value PSF.
     * @param obj
     * @returns {number}
     */
    var getMonthlyIndicatedValuePSF = function(obj) {
        if(obj.incomes.sqFeetAverage > 0 && obj.indicatedValueRange.monthly > 0) {
            return obj.indicatedValueRange.monthly/obj.incomes.sqFeetAverage;
        } else {
            return obj.indicatedValuePSF.monthly;
        }
    };

    /**
     * Calculate annual indicated value PSF.
     * @param obj
     * @returns {number}
     */
    var getAnnualIndicatedValuePSF = function(obj) {
        if(obj.incomes.sqFeetAverage > 0 && obj.indicatedValueRange.annual > 0) {
            return obj.indicatedValueRange.annual/obj.incomes.sqFeetAverage;
        } else {
            return obj.indicatedValuePSF.annual;
        }
    };

    /**
     * Calculate square feet indicated value PSF.
     * @param obj
     * @returns {number}
     */
    var getSqFtIndicatedValuePSF = function(obj) {
        if(obj.incomes.sqFeetAverage > 0 && obj.indicatedValueRange.sqFeet > 0) {
            return obj.indicatedValueRange.sqFeet/obj.incomes.sqFeetAverage;
        } else {
            return obj.indicatedValuePSF.sqFeet;
        }
    };



    /**
     * Calculate monthly indicated value PSF.
     * @param obj
     * @returns {number}
     */
    var getMonthlyIncrementalValuePSF = function(obj) {
        var incomeWeight = $('#income-approach-percentage').attr('data-value');
        if(!isNotNull(incomeWeight)) {
            incomeWeight = 0;
        }

        return obj.indicatedValueRange.monthly*(incomeWeight/100);
    };

    /**
     * Calculate annual indicated value PSF.
     * @param obj
     * @returns {number}
     */
    var getAnnualIncrementalValuePSF = function(obj) {
        var incomeWeight = $('#income-approach-percentage').attr('data-value');
        if(!isNotNull(incomeWeight)) {
            incomeWeight = 0;
        }

        return obj.indicatedValueRange.annual*(incomeWeight/100);
    };

    var isNotNull = function (value) {
        return !isNaN(value) && value !== null && value.length !== 0 && value !== undefined;
    };


    if (window.ApproachCalculator === undefined) {
        window.ApproachCalculator = {};
    }
    var calculateLeaseComps = function(isAddDelete = 0) {
        var values = ViewManager.getLeaseComps(isAddDelete);
        //Building size
        var buildingSize;
        if($("#selected_comp_type").val()=="land_only")
        {
            buildingSize = $('.comp-current').find("input[name='current[land_size]']").val();
            var dimensionInput = $('.comp-current').find("input[name='current[land_dimension]']");
            if (dimensionInput.val() === 'ACRE' && $('#selected_analysis_type').val() !== '$/Acre') {
                buildingSize = buildingSize * 43560; //convert to SF
            }
        }else{
            buildingSize = $('.comp-current').find("input[name='current[building_size]']").val();
        }
        
        //Total Average Adjusted
        if(values.totalAverageAdjusted > 0 && !isNaN(buildingSize)) {
            buildingSize = parseFloat(buildingSize);

            values.value = buildingSize * values.totalAverageAdjusted.toFixed(2);
        }
        ViewManager.setLeaseCompsValues(values);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };
    var calculateCapComps = function(isAddDelete = 0) {
        var values = ViewManager.getCapComps(isAddDelete);
        ViewManager.setCapCompsValues(values);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var calculateResSales = function(isAddDelete = 0, autoCalculate = 0) {
        var values = ViewManager.getResSalesValues(isAddDelete, autoCalculate);
        //Building size
        let buildingSize = $('.comp-current').find("input[name='current[building_size]']").val();
  
        //Total Average Adjusted
        if(values.totalAverageAdjusted) {
            buildingSize = parseFloat(buildingSize);
            values.compAdj = values.totalAverageAdjusted.toFixed(2);
            values.totalAverageAdjusted = (values.totalAverageAdjusted/buildingSize).toFixed(2);
            let finalValue = 0;
            $('.data').each(function() { 
                sqftValue = $(this).find('.sqft_value').val();
                weightValue = $(this).find('.weightsf_value').val();
                finalValue +=  getTotalSalesValue(values.totalAverageAdjusted,sqftValue,weightValue );               
            });
            values.value = finalValue;
        }

        //Incremental Value
        if(values.value > 0) {
            var salesWeight = $('#sales-approach-percentage').attr('data-value');
            if(!isNotNull(salesWeight)) {
                salesWeight = 0;
            }

            values.incrementalValue = (salesWeight/100) * values.value;
        }
        ViewManager.setResSalesValues(values);
        ViewManager.setResSidebar(values,isAddDelete);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('res_evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var calculateResCost = function(isAddDelete = 0) {
        var values = ViewManager.getResCostValues(isAddDelete);
        ViewManager.setResCostValues(values);
        ViewManager.setSidebar(values,isAddDelete);
        let segments = location.pathname.split("/");
        if(location.search && isInArray('res_evaluations', segments)){
            ViewManager.save();
            window.history.replaceState(null, null, window.location.pathname);
        }
        return values;
    };

    var calculateResIncome = function (save=0) {
        var values = ViewManager.getIncomeValues();

        //Net Income Total
        values.vacant = getVacantIncomeTotal(values);
        values.adjustedGross = getAdjustedGross(values);
        values.net = getNetIncomeTotal(values);

        //Indicated Value Range
        values.indicatedValueRange.monthly = getMonthlyIndicatedValueRange(values);
        values.indicatedValueRange.annual = getAnnualIndicatedValueRange(values);
        values.indicatedValueRange.sqFeet = getSqFtIndicatedValueRange(values);

        //Indicated Value PSF
        values.indicatedValuePSF.monthly = getMonthlyIndicatedValuePSF(values);
        values.indicatedValuePSF.annual = getAnnualIndicatedValuePSF(values);
        values.indicatedValuePSF.sqFeet = getSqFtIndicatedValuePSF(values);

        //Incremental Value PSF
        values.incrementalValue.monthly = getMonthlyIncrementalValuePSF(values);
        values.incrementalValue.annual = getAnnualIncrementalValuePSF(values);

        ViewManager.setIncomeValues(values);
        ViewManager.setResSidebar(values,save);

        return values;
    };


    var unitCalculation = function (){
        let unit_val = 0;
        $('.property-type-row').each(function () {
            if($(this).find('.property_type select').val() == 'multi_family'){
                unit_val += parseFloat($(this).find('.of_units').val().replace(/,/g, "")); 
            }
        });
        let unit_count_vals = 0;
        $('.unit-type-row').each(function(){
            unit_count_vals += parseFloat($(this).find('.unit_count_val').val().replace(/,/g, ""));
        });
        if(unit_count_vals == unit_val ){
           check_unit = true;
        }else{
           check_unit = false;
        }
        return check_unit;
    }

    let check_unit_val = '';

    var checkPropertyType = function(){
        let  check_multi_family = false;
        $('.property_type select').each(function() {
            if($(this).val() === 'multi_family')
            {
                check_multi_family = true;
            }
        });  
        return  check_multi_family ; 
    }
    ApproachCalculator.calculateIncomeApproach = calculateIncome;
    ApproachCalculator.calculateSalesApproach = calculateSales;
    ApproachCalculator.calculateCostApproach = calculateCost;
    ApproachCalculator.calculateAge = calculateAge;
    ApproachCalculator.redefineWeight = redefineWeight;
    ApproachCalculator.updateSidebar = updateSidebar;
    ApproachCalculator.calculateLeaseComps = calculateLeaseComps;
    ApproachCalculator.calculateCapComps = calculateCapComps;
    ApproachCalculator.calculateResSalesApproach = calculateResSales;
    ApproachCalculator.calculateResCostApproach = calculateResCost;
    ApproachCalculator.calculateResIncomeApproach = calculateResIncome;
    ApproachCalculator.calculateUnits = unitCalculation ;
    ApproachCalculator.checkPropertyType = checkPropertyType ;
    ApproachCalculator.check_unit_val = check_unit_val ;
    ApproachCalculator.calculateMultiFamilyApproach = calculateMultiFamilyApproach;
})();